import { render, staticRenderFns } from "./PhoneAddressCard.vue?vue&type=template&id=b43a09cc&scoped=true"
import script from "./PhoneAddressCard.vue?vue&type=script&lang=js"
export * from "./PhoneAddressCard.vue?vue&type=script&lang=js"
import style0 from "./PhoneAddressCard.vue?vue&type=style&index=0&id=b43a09cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43a09cc",
  null
  
)

export default component.exports